import { useEffect } from "react";

export const QUIZ_FOCUS_EVENT = "quiz-focus-mode";

export const useFocusMode = (isLocked, quizStateChange) => {
  useEffect(() => {
    const prevOverflow = document.body.style.overflow;
    if (isLocked) {
      document.body.style.overflow = "hidden";
    }

    window.dispatchEvent(
      new CustomEvent(QUIZ_FOCUS_EVENT, { detail: { locked: Boolean(isLocked) } })
    );

    return () => {
      document.body.style.overflow = prevOverflow;
      window.dispatchEvent(
        new CustomEvent(QUIZ_FOCUS_EVENT, { detail: { locked: false } })
      );
      if (typeof quizStateChange === "function") {
        quizStateChange(false);
      }
      localStorage.removeItem("currentQuestion");
    };
  }, [isLocked, quizStateChange]);
};